import TypeToReducer from 'type-to-reducer';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

import {
  SET_SELECTED_ASSET,
  SET_ENABLE_ASSET_MODAL_IS_OPEN,
  SEND_TOKEN_ASIGN,
} from 'containers/assets/constants';

export const initialState = {
  asset: null,
  enableModalIsOpened: false,
  isSending: false,
  isLoading: false,
};

export const sendTokenAsignPending = (state) => ({
  ...state,
  isSending: true,
  isLoading: true,
});
export const sendTokenAsignRejected = (state) => ({
  ...state,
  isSending: false,
  isLoading: false,
});

export const sendTokenAsignFulfilled = (state, { payload }) => ({
  ...state,
  isSending: false,
  isLoading: false,
});

export const actionsReducers = {
  [SET_SELECTED_ASSET]: (state, { payload }) => ({ ...state, asset: payload }),
  [SEND_TOKEN_ASIGN]: {
    [PENDING]: sendTokenAsignPending,
    [REJECTED]: sendTokenAsignRejected,
    [FULFILLED]: sendTokenAsignFulfilled,
  },
  [SET_ENABLE_ASSET_MODAL_IS_OPEN]: (state, { payload }) => ({
    ...state,
    enableModalIsOpened: payload,
  }),
};

export default TypeToReducer(actionsReducers, initialState);



// WEBPACK FOOTER //
// src/containers/assets/reducers_actions.js